import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { useIntl } from 'react-intl';

import { CardModal } from 'components/card-modal';
import { LocationEmptyState } from 'components/location-empty-state';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuObjectPage } from 'pages/menu/menu-object-page';
import { MenuProductPage } from 'pages/menu/menu-product-page/menu-product-page';

export default function MenuObject() {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const { formatMessage } = useIntl();
  const { noStoreSelected } = useStoreRequired();
  if (noStoreSelected) {
    return (
      <CardModal alwaysShowHeader>
        <LocationEmptyState
          title={formatMessage({ id: 'emptyMenuHeading' })}
          message={formatMessage({ id: 'emptyMenuMessage' })}
        />
      </CardModal>
    );
  }

  return enableUnifiedMenu ? <MenuProductPage /> : <MenuObjectPage />;
}
